<script setup>
definePage({ meta: { layout: 'auth' } });
const router = useRouter();

import { consumeReturnPath } from '@/composables/usePartnerLinkReturn';

onMounted(() => {
  // partner/smartwel 연동 흐름으로 진입한 사용자라면 일반 완료 UI 대신 partner 페이지로 자동 복귀.
  const returnPath = consumeReturnPath();
  if (returnPath) {
    window.location.href = returnPath;
    return;
  }

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-10814485333/UF0SCK_t14waENXm36Qo',
    });
  }
});

const onClickConfirm = () => router.push('/mypage/moreinfo');

const onClickLater = () => router.push('/main');
</script>

<template>
  <div class="auth-page">
    <div class="auth-page__content">
      <div class="step-indicator">
        <div class="step-complete">
          <img src="../../assets/images_manse/check_circle.png" alt="Logo" width="80" height="80" />
          <img src="../../assets/images_manse/logo_b.png" alt="Logo" width="140" height="53" />
        </div>
      </div>
      <div class="form-title">회원이 되신 것을 환영합니다.</div>
      <div class="form-description form-description--complete">
        이용권을 구독하시면 더욱 편리하게<br />만세력 이용을 하실 수 있습니다.
      </div>

      <div class="benefit-box">
        <div class="benefit-title">🎁 사주와 정보를 등록하면 혜택도!</div>
        <div class="benefit-item">👉 포인트 최대 400P</div>
        <div class="benefit-item">👉 궁합 1회 무료 체험</div>
      </div>

      <button class="confirm-btn btn active" @click="onClickConfirm">사주 등록하고 시작하기</button>

      <button class="later-btn" @click="onClickLater">나중에 할게요</button>
    </div>
  </div>
</template>
